import {Outlet} from 'react-router-dom';
import {toAbsoluteUrl} from '../../../_metronic/helpers';

const ErrorsLayout = () => {
    return (
        <div id={'error-page'} className="d-flex flex-column flex-root bg-white">
            <div className={'p-4'}>
                <img
                    src={toAbsoluteUrl('/media/logos/LOGO_CELESTE_Sans_Baseline_Bleu.png')}
                    className="align-self-start mh-40px mb-5"
                    alt={
                        "Logo Céleste bleu foncé avec le nom de la société et l'étoile bleu de la société"
                    }
                />
            </div>

            <div className="d-flex flex-column flex-center flex-column-fluid">
                <div className="card card-flush text-center w-lg-850px">
                    <div className="card-body">
                        <Outlet />
                    </div>
                </div>
            </div>
        </div>
    );
};

export {ErrorsLayout};
